import axios from "axios"
import { RegistrarLogErro } from "./functions"

const url = "https://5anmf3q26c.execute-api.us-east-1.amazonaws.com/api"

const apiAgendamento = axios.create({
    baseURL: url,
})

export async function buscarConfiguracoesAgendamento(idEstabelecimento: number): Promise<any> {
    const url = `/agendamento/configuracoes/buscar/${idEstabelecimento}`
    const headers = {
        "Content-Type": "application/json",
    }

    try {
        const response = await apiAgendamento.get(url, { headers: headers })
        return response.data
    } catch (error) {
        RegistrarLogErro(error, "buscarConfiguracoesDeAgendamento")
        console.log(error)
    }
}

export async function buscarPeriodosDeAgendamento(
    data: any,
    idEstabelecimento: number
): Promise<any> {
    const url = `/agendamento/periodos/buscar/site/${data}/${idEstabelecimento}`
    const headers = {
        "Content-Type": "application/json",
    }

    try {
        const response = await apiAgendamento.get(url, { headers: headers })
        return response.data
    } catch (error) {
        RegistrarLogErro(error, "buscarPeriodosDeAgendamento")
        console.log(error)
    }
}

export async function buscarPedidosAgendadosCliente(idCliente: number): Promise<any> {
    const url = `/agendamento/pedidos/buscar/cliente/${idCliente}`
    const headers = {
        "Content-Type": "application/json",
    }

    try {
        const response = await apiAgendamento.get(url, { headers: headers })
        return response.data
    } catch (error) {
        RegistrarLogErro(error, "buscarPeriodosDeAgendamento")
        console.log(error)
    }
}
